import { render, staticRenderFns } from "./XmTitle.vue?vue&type=template&id=985e777a&scoped=true"
import script from "./XmTitle.vue?vue&type=script&lang=js"
export * from "./XmTitle.vue?vue&type=script&lang=js"
import style0 from "./XmTitle.vue?vue&type=style&index=0&id=985e777a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "985e777a",
  null
  
)

export default component.exports